import { render, staticRenderFns } from "./ItemsRenderer.vue?vue&type=template&id=047ac723"
import script from "./ItemsRenderer.vue?vue&type=script&lang=ts"
export * from "./ItemsRenderer.vue?vue&type=script&lang=ts"
import style0 from "./ItemsRenderer.vue?vue&type=style&index=0&id=047ac723&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('047ac723')) {
      api.createRecord('047ac723', component.options)
    } else {
      api.reload('047ac723', component.options)
    }
    module.hot.accept("./ItemsRenderer.vue?vue&type=template&id=047ac723", function () {
      api.rerender('047ac723', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ItemsRenderer.vue"
export default component.exports